export interface QuestionnaireValueResInterface {
  rid: number
  fieldId: number
  value: object
  otherValue: object[]
}

export class QuestionnaireValueRes implements QuestionnaireValueResInterface {
  rid: number
  fieldId: number
  value: object
  otherValue: object[]

  constructor(props: QuestionnaireValueResInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      rid: _rid,
      fieldId: _fieldId,
      value: _value,
      otherValue: _otherValue,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.rid = _rid
    this.fieldId = _fieldId
    this.value = _value
    this.otherValue = _otherValue
  }
}
